// Secciones de Validación de Hipótesis PMV (Lean Startup)
// Los section_title deben coincidir con PMV_QUESTIONS del backend pmv_service.py
export const PMV_SECTIONS = [
  { id: 'hipotesis_problema', title: 'Hipótesis del problema' },
  { id: 'segmento_objetivo', title: 'Segmento objetivo' },
  { id: 'propuesta_valor_pmv', title: 'Propuesta de valor PMV' },
  { id: 'hipotesis_solucion', title: 'Hipótesis de la solución' },
  { id: 'metricas_clave', title: 'Métricas clave' },
  { id: 'diseno_experimento', title: 'Diseño del experimento' },
  { id: 'criterios_pivote', title: 'Criterios de pivote' },
  { id: 'aprendizajes_iteracion', title: 'Aprendizajes e iteración' },
];

// Bloques con respuesta predefinida (sin consumo de IA).
// Deben coincidir con _PREDEFINED_PMV_BLOCKS del backend pmv_service.py
export const PREDEFINED_PMV_SECTIONS = new Set([
  'Segmento objetivo',
  'Métricas clave',
  'Diseño del experimento',
  'Criterios de pivote',
  'Aprendizajes e iteración',
]);
